import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import OffersActions from "../libs/Offers";
import CustomSpinner from "../../components/CustomSpinner";

export default function ConfirmAcceptOffer() {
  const [companyName, setCompanyName] = useState("");
  const {t} = useTranslation();
  const {token} = useParams();

  useEffect(() => {
    OffersActions.confirmAcceptOffer(token)
        .then((res) => {
          setCompanyName(res.company_name);
        })
        .catch((error) => console.log(error));
  }, []);

  return (
      <div
          className="d-flex  flex-column align-items-center mt-5 fs-1"
      >
        {companyName ? <h4>{t("Congratulations! You have received offer from")} {companyName}</h4> : <CustomSpinner/>}
      </div>
  );
}
